export const FormColumnWidgetId = 'FormColumnWidget';

export enum FormColumnWidgetAttributes {
  ELEMENTS = 'formColumnElements',
}
